module.exports = __webpack_public_path__ + "img/Panin Dubai Syariah.3d19236a.png";